import { Component, OnInit, AfterViewInit, Input, EventEmitter, Output, ChangeDetectionStrategy, ChangeDetectorRef, forwardRef, ViewChildren, ElementRef, HostBinding, HostListener, QueryList, ViewChild, Renderer2 } from '@angular/core';
import { InfoDay } from '../../comun/recipient-services/info-day';
import { BaseComponent } from '../../base-component';
import { ExpeditionsService } from '../../services/expeditions.service';
import { ErrorModalComponent } from '../../error-modal/error-modal.component';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { ShipmentChangesService } from '../../services/shipment-changes/shipment-changes.service';

export const DAY_SELECTION_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DaySelectionComponent),
  multi: true
};
@Component({
  selector: 'day-selection',
  templateUrl: './day-selection.component.html',
  styleUrls: ['./day-selection.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DAY_SELECTION_CONTROL_VALUE_ACCESSOR]
})
export class DaySelectionComponent extends BaseComponent implements OnInit, AfterViewInit, ControlValueAccessor {

  @Input() active: boolean;
  @Input() totalDays: number;
  value: string;
  @Output() selection = new EventEmitter<InfoDay>();
  days: InfoDay[];
  private divsDays: Array<ElementRef>;
  private originalsText: Array<string>;
  @ViewChildren('divDiaSemana') queryDivDiaSemana: QueryList<ElementRef>;
  @ViewChild('contenedorInterno', { static: true }) contenedorInterno: ElementRef;
  @ViewChild('contenedorDias', { static: true }) contenedorDias: ElementRef;
  private high: number;
  private highContent: number;
  private positionScroll = 0;
  onChange: any = Function.prototype;
  onTouched: any = Function.prototype;
  writeValue(date: string): void {
    this.value = date;
  }

  registerOnChange(fn: (_: any) => {}): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }


  constructor(
    private service: ExpeditionsService, 
    private cdr: ChangeDetectorRef, 
    private renderer: Renderer2,
    private servicepointsService: ShipmentChangesService,
    ) {
    super();
  }

  clickDia(day: InfoDay) {
    this.writeValue(day.Date);
    this.onChange(this.value);
    this.selection.emit(day);
  }



  ngOnInit() {

    const expedition = this.sesion.expedition$.getValue();
    this.servicepointsService.daysAvailableChangeDelivery(expedition.TLGNumber, this.totalDays)
      .subscribe(days => {
        this.days = days;
        this.originalsText = new Array<string>();
        days.forEach(infoDay => {
          this.originalsText.push(infoDay.DayOfWeek);
        });
        this.cdr.detectChanges();
      }, err => {
        ErrorModalComponent.show(err);
      });

  }

  ngAfterViewInit(): void {
    this.queryDivDiaSemana.changes.subscribe(divs => {
      this.divsDays = divs;
      this.checkHigh();
      this.cdr.detectChanges();
    });
  }

  @HostListener('window: resize')
  onWindowResize() {
    if (this.days) {
      if (this.originalsText) {
        this.days.forEach((infoDay, index) => {
          infoDay.DayOfWeek = this.originalsText[index];
        });
      }
      this.cdr.detectChanges();
      this.checkHigh();
      this.cdr.detectChanges();
    }
  }



  private checkHigh() {
    let high = 0;
    let someGetsOutOfControl = false;
    this.divsDays.forEach(divDia => {

      const div: HTMLDivElement = divDia.nativeElement;
      if (high != 0 && high != div.clientHeight) {
        someGetsOutOfControl = true;
      }
      if (high < div.clientHeight) {
        high = div.clientHeight;
      }
    });

    if (someGetsOutOfControl) {
      this.divsDays.forEach((divDia, index) => {
        const div: HTMLDivElement = divDia.nativeElement;
        const infoDay = this.days[index];

        if (high > div.clientHeight) {
          infoDay.DayOfWeek = infoDay.DayOfWeek + '<br/>&nbsp;';
        }
      });
      this.cdr.detectChanges();
    }
    this.high = (<HTMLDivElement>this.contenedorDias.nativeElement).clientHeight;
    this.highContent = (<HTMLDivElement>this.contenedorInterno.nativeElement).clientHeight;

  }

  get scrollAboveEnabled(): boolean {
    return this.positionScroll < 0;
  }
  get scrollDownEnabled(): boolean {
    return this.positionScroll * -1 < this.highContent - this.high;
  }
  scrollAbove() {
    const container = this.contenedorInterno.nativeElement;
    this.positionScroll = this.positionScroll + this.high;
    this.renderer.setStyle(container, 'top', this.positionScroll.toString() + 'px');
  }
  scrollDown() {
    const container = this.contenedorInterno.nativeElement;
    this.positionScroll = this.positionScroll - this.high;
    this.renderer.setStyle(container, 'top', this.positionScroll.toString() + 'px');
  }
}
